import React, { Component, Fragment } from "react";
import Subscribe from "./subscribe/Subscribe";
import SocialBlock from "./socialBlock/SocialBlock";
import {IMPORTANT_LINKS_API_URL} from "../../../store/constants/urls";
import { SETTINGS_API_URL } from "../../../store/constants/urls";
import "./footer.css";

export default class Footer extends Component {
  state = {
    importantLinks: [],
    linksLoaded: false,
  };

  componentDidMount() {
    
    if (this.state.linksLoaded==false){
    let url = `${IMPORTANT_LINKS_API_URL}`;
    let self = this;
    fetch(url)
        .then(res => res.json())
        .then(data => {
            if (data.length>0){
              this.setState({
                'importantLinks' : data,
              });
            };
            this.setState({
              'linksLoaded' : true,
            });
    });
   }
  if  ( (window.location.pathname == "/" || window.location.pathname == '/contact') && !this.state.subscriptionLoaded)
  {
    let url = `${SETTINGS_API_URL}`;
    fetch(url)
      .then(res => res.json())
      .then(data => {
            this.setState({
              'subscriptionUrl' : data.data[5]['subscription_url'],
              'subscriptionLoaded' : true,
            });
  });
  }
  else {
    this.setState({
      'subscriptionLoaded' : true,
    });

  }
  }

  renderLinksList = () => {
    let link;
    let renderList = [];
    for (link in this.state.importantLinks){
      let oneLink = (
        <li><a href={this.state.importantLinks[link].url}
          target="_blank">
          {this.state.importantLinks[link].title}
          </a></li>
      );
      renderList.push(oneLink);
      
    }
   return renderList;
  }


  render() {
    let {linksLoaded,importantLinks} = this.state;
    
    let { pathname } = window.location;
    if (!linksLoaded){
      return (<div></div>);
    }
    else {
    return (
      <Fragment>
        {/* {pathname !== "/subscription"  && <Subscribe />} */}
        {(pathname == "/" || pathname == '/contact') && (
            <Fragment>
              <Subscribe/>
              <div className="clearfix" />
              <SocialBlock />
            </Fragment>
          )}
        <footer>
          <div id="upper-footer">
            <div className="container">
              <div className="row">
                <div className="col-xs-12 col-sm-4">
                  <div className="footer-title">
                    <h1>contact address</h1>
                  </div>
                  <div className="footer-detail">
                    <i className="fa fa-home" />
                    <p className="bold">
                      housing recovery & reconstruction platform
                    </p>
                    <p>Jwagal, Lalitpur, Nepal</p>
                  </div>
                  <div className="footer-detail">
                    <i className="fa fa-phone" />
                    <p>+977-1-5544149</p>
                  </div>
                  <div className="footer-detail">
                    <i className="fa fa-envelope" />
                    <p>
                      <a href="mailto:info@hrrpnepal.org">info@hrrpnepal.org</a>
                    </p>
                  </div>
                {/* <div className="footer-detail">
                  <img src="/img/CRS-logo-Copy.png" alt="" />
                  <img src="/img/uk_aid.png" alt="" style={{marginLeft:'20px'}} />
                </div> */}

                  {/*<ul className="list-unstyled list-inline footer-social">*/}
                    {/*<li>*/}
                      {/*<a*/}
                        {/*href="https://www.facebook.com/HRRPNepal/"*/}
                        {/*target="_target"*/}
                      {/*>*/}
                        {/*<img src="/img/facebook.png" alt="" />*/}
                      {/*</a>*/}
                    {/*</li>*/}
                    {/*<li>*/}
                      {/*<a href="https://twitter.com/HRRP_Nepal" target="_blank">*/}
                        {/*<img src="/img/twitter.png" alt="" />*/}
                      {/*</a>*/}
                    {/*</li>*/}
                    {/*<li>*/}
                      {/*<a href="https://flipboard.com/@HRRP" target="_blank">*/}
                        {/*<img src="/img/flipboard.png" alt="" />*/}
                      {/*</a>*/}
                    {/*</li>*/}
                    {/*<li>*/}
                      {/*<a*/}
                        {/*href="https://www.flickr.com/photos/hrrp"*/}
                        {/*target="_blank"*/}
                      {/*>*/}
                        {/*<img src="/img/flickr.png" alt="" />*/}
                      {/*</a>*/}
                    {/*</li>*/}
                  {/*</ul>*/}
                </div>
                <div className="col-xs-12 col-sm-4">
                  <div className="footer-title">
                    <h1>important links</h1>
                  </div>

                  <ul className="footer-ul">

                  {this.renderLinksList()}
                  {/* {importantLinks.map(importantLink => 
                  <li>
                      <a href={importantLink['url']} target="_blank">
                          {importantLink['title']}
                      </a>
                  </li>
                    )} */}
                  </ul>

                  {/* <div className="feedback footer-title">
                                        <h1>feedback</h1>
                                    </div>
                                    <NavLink to="/contact">
                                        <div className="footer-detail">
                                            For feedback click here: <button className="btn btn-danger">FEEDBACK</button>
                                        </div>
                                    </NavLink> */}
                </div>
                <div className="col-xs-12 col-sm-4">
                  <div className="footer-title">
                    <h1>social pages</h1>
                  </div>
                  <div className="footer-detail">
                    <i className="fa fa-facebook" />
                    <p className="text-capitalize">
                      <a
                        href="https://www.facebook.com/nhsrpnepal/"
                        target="_target"
                      >
                        HRRP nepal facebook page
                      </a>
                    </p>
                  </div>
                  <div className="footer-detail">
                    <img
                      src="/img/flipboard.svg"
                      alt=""
                      style={{
                        width: "15px",
                        height: "15px",
                        float: "left",
                        marginTop: "4px"
                      }}
                    />
                    <p className="text-capitalize">
                      <a href="https://flipboard.com/@HRRP">
                        HRRP nepal flipboard page
                      </a>
                    </p>
                  </div>
                  <div className="footer-detail">
                    <i className="fa fa-twitter" />
                    <p className="text-capitalize">
                      <a href="https://twitter.com/HRRP_Nepal" target="_blank">
                        HRRP nepal twitter page
                      </a>
                    </p>
                  </div>
                  <div className="footer-detail">
                    <i className="fa fa-flickr" />
                    <p className="text-capitalize">
                      <a
                        href="https://www.flickr.com/photos/hrrp"
                        target="_blank"
                      >
                        HRRP nepal flickr page
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="bottom-footer">
            <div className="container">
              <div className="row">
                <div className="col-xs-12 col-sm-6">
                  <small>
                    &copy; Copyright 2024 HRRP Nepal. All right reserved
                  </small>
                </div>

                <div className="col-xs-12 col-sm-6 text-right">
                  <small className="">
                    Powered by:{" "}
                    <a href="//yarshastudio.com/" target="_blank">
                      Yarsha Studio
                    </a>
                  </small>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </Fragment>
    );
  }
}
}
